import React from "react";
import Loader from "../../Loader";
import { formStyles } from "../formStyles";

export default function LoginStep(props) {
  const { register, errors, handleChange, handleSubmit, onLogin, isVerifying, setStep } = props;

  return (
    <div className="max-w-md mx-auto bg-white p-8 rounded-2xl shadow-sm border border-gray-100">
      <h2 className="text-2xl font-bold text-center text-slate-900 mb-6">Login to Portal</h2>
      <div className="mb-5">
        <label className={formStyles.label}>
          Email Address <span className="text-red-500">*</span>
        </label>
        <input type="email" {...register("login_email", { required: true })} onChange={handleChange} className={formStyles.input} placeholder="Enter your registered email" />
        {errors.login_email && <p className="mt-1 text-sm text-red-500">Email is required</p>}
      </div>
      <button onClick={handleSubmit(onLogin)} className={`${formStyles.buttonPrimary} w-full`}>
        Secure Login {isVerifying && <span className="ml-2"><Loader /></span>}
      </button>
      <p className="mt-6 text-center text-slate-600">
        Don't have a profile? <button type="button" onClick={() => setStep(1)} className="font-bold text-blue-600 hover:text-blue-700">Create one now</button>
      </p>
    </div>
  );
}